export const getBookingErrorType = (status, t, bookingId) => {
  const map = {
    500: {
      title: t('error.bookingInternalServerTitle'),
      message: t('error.bookingInternalServerSubDesc'),
    },
    404: {
      title: t('error.bookingNotFoundTitle'),
      message: t('error.bookingNotFoundSubDesc', { bookingId }),
    },
    403: {
      title: t('error.bookingForbiddenTitle'),
      message: t('error.bookingForbiddenSubDesc'),
    },
  }

  // return matching error OR fallback to 500
  return map[status] || map[500]
}
